export default __webpack_public_path__ + "static/media/client-9.b8554e8b.png";